import React from 'react';
import { connect } from 'react-redux';
import { Header } from 'app/components/Header';
import * as FormActions from 'app/actions/form/actions';
import { getSectionFromLocation } from 'app/routes';
import { routes } from 'app/routes/route-list';
import { isOnLoanOfficerSite } from 'app/util/headers';
import { getSalesforceParams } from 'app/api/helpers';

class HeaderComponent extends React.Component<any, any> {
  render() {
    return <Header {...this.props} />;
  }
}

const mapStateToProps = (state: any) => {
  const params = getSalesforceParams();
  return {
    isSalesforce           : Object.keys(params).length,
    logo                   : state.config.logo,
    activeSection          : getSectionFromLocation(state.router.location),
    hasDisableLogoRedirect : state.config.featureToggles.hasDisableLogoRedirect,
    isRootRoute            : state.router.location.pathname === routes.root,
    hasContactUsLink       : state.router.location.pathname !== routes.contact &&
      state.router.location.pathname !== routes.homeEquityRates,
    isOnLoanOfficerSite    : isOnLoanOfficerSite(),
  };
};

const mapDispatchToProps = FormActions;

export default connect(mapStateToProps, mapDispatchToProps)(HeaderComponent);
